<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="600px"
  >
    <priority-dialog
      v-model="isPriorityDialogOpened"
      :maker="maker"
      @save="priorityAdded"
    />
    <v-card v-if="maker">
      <v-card-title>
        Priorités d'intervention
      </v-card-title>
      <v-card-subtitle>
        {{ maker.name }}
      </v-card-subtitle>
      <v-divider />
      <v-card-text class="pa-3 mb-2">
        <v-row no-gutters justify="center" align="center" class="pt-6 pb-4" v-if="isFetchingPriorities">
          <v-progress-linear
            indeterminate
            color= "primary"
            style="max-width: 200px;"
          />
        </v-row>
        <template v-else>
          <v-row no-gutters justify="center" align="center" class="pa-2 mt-2 text--secondary" style="min-height: 50px;" v-if="!priorities.length">
            Aucune priorité
          </v-row>
          <v-row class="px-4 py-1" :justify="priorities.length % 2 === 0 ? `center` : `start`" align="center">
            <v-col cols="6" v-for="priority in priorities" :key="priority.id">
              <n-card depressed class="px-3 py-1 font-weight-medium" style="background: #EEE;">
                {{ priority.name }}
              </n-card>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters justify="center" align="center">
                <v-btn :disabled="!$canWrite" text color="primary" class="mx-2" @click="$canWrite && (isPriorityDialogOpened = true)">
                  <v-icon left>add</v-icon>
                  Nouvelle priorité
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align="center" v-if="!priorities.length">
            <v-btn text small color="primary lighten-2" class="mx-2 mt-4" @click="generateProposedPriorities">
              Ou générer les priorités {{ proposedPrioritiesTxt }}
            </v-btn>
          </v-row>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-3 px-6">
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          :disabled="priorities.length < 1"
          @click="ended"
        >
          Étape suivante
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PriorityDialog from '@/components/Priority/PriorityDialog.vue';

export default {
  name: `SavePriority`,
  props: {
    value: Boolean,
    maker: Object,
  },
  data: () => ({
    proposedPriorities: [`Faible`, `Normale`, `Urgente`],
    priorities: [],
    isFetchingPriorities: false,
    isPriorityDialogOpened: false,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
    proposedPrioritiesTxt() {
      let txt = ``;
      this.proposedPriorities.forEach((priority, i) => {
        let separator = `, `;
        if (i === 0) {
          separator = ``;
        } else if (i === this.proposedPriorities.length - 1) {
          separator = ` et `;
        }
        txt = `${txt}${separator}"${priority}"`;
      });

      return txt;
    },
  },
  methods: {
    initLocalState() {
      this.priorities = [];
      this.fetchPriorities();
    },
    ended() {
      this.isOpened = false;
      this.$emit(`ended`);
    },
    async fetchPriorities() {
      this.isFetchingPriorities = true;
      this.$store.commit(`model/priority/SET_MAKER_PRIORITIES`, []);
      const priorities = await this.$store.dispatch(`model/priority/fetchMakerPriorities`, this.maker.id);
      this.priorities.push(...priorities);
      this.isFetchingPriorities = false;
    },
    async generateProposedPriorities() {
      const priorities = await Promise.all(this.proposedPriorities.map(priority =>
        this.$store.dispatch(`model/priority/addPriority`, {
          id: ``,
          name: priority,
          makerId: this.maker.id,
        })
      ));
      this.priorities.push(...priorities);
    },
    priorityAdded(priority) {
      this.priorities.push(priority);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
  components: {
    PriorityDialog,
  },
};
</script>
